import { Drawer, Toolbar, Box, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { FIRST_MILE_TABS } from './FirstMileTabsList';
import { cloneDeep, includes } from 'lodash';
import { DrawerList, DrawerCurrentUserStatus, DrawerAccountWelcome } from '../components';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { USER_ROLES, USER_ROLES_TYPES, ZSHIP_ID } from 'src/constants';
import { useMemo } from 'react';
import { AccountCircle, Person } from '@mui/icons-material';
const drawerWidth = 260;

export default function FirstMileDrawer({ openDrawer, toggleDrawer }) {
    const { pathname } = useLocation();
    const profile = useSelector((state) => state.entities.profile.profile);

    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));

    const tabs = useMemo(() => {
        let role = profile?.role
        let type = profile?.type

        let clone = cloneDeep(FIRST_MILE_TABS)
        if (role !== USER_ROLES.MERCHANT && type !== USER_ROLES_TYPES.ADMIN) {
            clone = clone?.filter(el => el.title !== "Account")
        }
        if (!profile?.merchant?.onlinePayment) {
            clone = clone?.filter(el => el.href !== "/merchant/transactions")
        }
        if (!!profile?.merchant?.salla?.store_id || !!profile?.merchant?.zid?.store_id) {
            let index = clone?.findIndex(el => el.title === "Account")
            clone[index].children = clone[index]?.children?.filter(el => !["/merchant/account/plans", "/merchant/account/subscription"].includes(el.href))
        }
        return clone
    }, [profile, FIRST_MILE_TABS])

    useEffect(() => {
        if (downLg && openDrawer) {
            toggleDrawer();
        }
    }, [pathname, downLg]);
    return (
        <Drawer
            open={openDrawer}
            onClose={toggleDrawer}
            variant={downLg ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <DrawerAccountWelcome companyName={profile?.merchant?.companyName} logo={profile?.merchant?.logo}  />
                {/* {
                    !!profile?.merchant?.currentStatus && includes(["BLOCKED", "WAITING", "PLAN_EXPIRED", "CARD_REQUIRED"], profile?.currentStatus) &&
                    <DrawerCurrentUserStatus currentStatus={profile?.merchant?.currentStatus} />
                } */}
                <DrawerList tabs={tabs.filter(tab => !(tab?.name === "Current package" && ZSHIP_ID.includes(profile?.merchant?.id)))} />
            </Box>
        </Drawer>
    )
}